import { useState } from 'react';

export default function LazyImg({ src, alt, className = '' }) {
  const [on, setOn] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={`${className}${on ? ' is-on' : ''}`}
      ref={(node) => {
        if (node && node.complete && node.naturalWidth > 0) setOn(true);
      }}
      onLoad={() => setOn(true)}
      onError={(event) => {
        event.currentTarget.style.display = 'none';
      }}
    />
  );
}
